import React from 'react';
import { GrClose } from 'react-icons/gr';

import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  background-color: white;
  display: flex;
  flex-direction: column;
`;

const Children = styled.div`
  z-index: 2;
`;

const CloseContainer = styled.div`
  transition: all 0.3s ease;
  position: absolute;
  top: -15px;
  right: -20px;
  width: var(--larger-size);
  height: var(--larger-size);
  background-color: var(--tts-blue);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  cursor: pointer;
  z-index: var(--z-index-banner);

  .icon {
    path {
      stroke: var(--tts-white);
    }
  }

  &:hover,
  &:focus {
    background: var(--tts-purple);
  }
`;

interface ModalProps {
  children?: React.ReactNode;
  className?: string;
  onClose: React.MouseEventHandler;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
}

const Modal = ({
  children,
  className,
  onClose,
  onMouseDown,
  onMouseUp,
}: ModalProps): React.ReactElement => {
  return (
    <Container onClick={e => e.stopPropagation()} onMouseDown={onMouseDown} onMouseUp={onMouseUp}>
      <CloseContainer onClick={onClose}>
        <GrClose className={'icon'} />
      </CloseContainer>
      {children && <Children className={className}>{children}</Children>}
    </Container>
  );
};

export default Modal;
